<template>
  <div class="product-cart-checkout">
    <div v-if="quantity" ref="items" class="product-cart-checkout__items">
      <product-cart-item v-for="item in items" :key="item.id" v-bind="{ item, apiUrl }" />
    </div>
    <div v-else ref="empty" class="product-cart-checkout__empty">{{ emptyText }}</div>
    <div class="product-cart-checkout__footer">
      <product-cart-buttom @click="onCloseClick">{{ closeText }}</product-cart-buttom>
      <product-cart-buttom v-if="quantity" :primary="true" :href="cartUrl">{{
        checkoutText
      }}</product-cart-buttom>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import { mapGetters } from 'vuex';
import ProductCartItem from './product-cart-item.vue';
import ProductCartButtom from './product-cart-buttom.vue';

export default {
  name: 'product-cart-checkout',
  components: {
    [ProductCartItem.name]: ProductCartItem,
    [ProductCartButtom.name]: ProductCartButtom,
  },
  props: {
    checkoutUrl: {
      type: String,
      required: true,
    },
    checkoutText: {
      type: String,
      required: true,
    },
    emptyText: {
      type: String,
      required: true,
    },
    closeText: {
      type: String,
      required: true,
    },
    apiUrl: {
      type: String,
      required: true,
    },
  },
  computed: {
    cartUrl() {
      return `${this.checkoutUrl}?orderFormId=${this.id}#/cart`;
    },
    isMobile() {
      return window.innerWidth < 768;
    },
    ...mapGetters('cart', ['id', 'quantity', 'items']),
  },
  methods: {
    onCloseClick(event) {
      event.preventDefault();

      this.$store.commit('cart/toggle', false);
    },
    setHeight: debounce(function () {
      let height = '';

      // On some mobile devices, the value 100vh may not work correctly due to an upper
      // bar, so the calculation of the difference in the header added to the buttons is
      // subtracted from the window internal height.
      if (this.isMobile) {
        height = `${window.innerHeight - (50 + 40)}px`;
      }

      const target = this.$refs.items || this.$refs.empty;

      if (target) {
        target.style.setProperty('height', height);
      }
    }, 150),
    setOverflow(hidden) {
      const toggle = this.isMobile && hidden;

      // On iOS devices, it is necessary to use the "height" and "overflow" properties
      // together, to disable scrolling.
      document.documentElement.style.setProperty('height', toggle ? '100%' : '');
      document.documentElement.style.setProperty('overflow', toggle ? 'hidden' : '');
      document.body.style.setProperty('height', toggle ? '100%' : '');
      document.body.style.setProperty('overflow', toggle ? 'hidden' : '');
    },
  },
  mounted() {
    this.setOverflow(true);
    this.setHeight();

    window.addEventListener('resize', this.setHeight);
  },
  destroyed() {
    this.setOverflow(false);
    this.setHeight();

    window.removeEventListener('resize', this.setHeight);
  },
};
</script>

<style lang="scss">
@import './product-cart-checkout';
</style>
